import { gql } from "@apollo/client";

//Obtener todas las plazas
export const OBTENER_PLAZAS = gql`
  query OBTENER_PLAZAS {
    obtenerPlazas {
      id
      nombre
      activo
    }
  }
`;

//Agregar plaza
export const AGREGAR_PLAZA = gql`
  mutation AGREGAR_PLAZA($input: InputPlaza) {
    agregarPlaza(input: $input)
  }
`;
export const OBTENER_INFO_PLAZA = gql`
  query OBTENER_PLAZA($id: ID!) {
    obtenerPlaza(id: $id) {
      id
      nombre
    }
  }
`;
export const EDITAR_PLAZA = gql`
  mutation EDITAR_PLAZA($input: UpdatePlaza) {
    editarPlaza(input: $input)
  }
`;

//
export const ACTIVAR_REGISTRO = gql`
  mutation ACTIVAR_PLAZA($id: ID!) {
    activarPlaza(id: $id)
  }
`;
export const DESACTIVAR_REGISTRO = gql`
  mutation DESACTIVAR_PLAZA($id: ID!) {
    desactivarPlaza(id: $id)
  }
`;
